// Slick Slider for .customslick__slider
$('.customslick__slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  speed: 1000,  // Adjust speed for smooth transition
  cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
  pauseOnHover: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        infinite: true,
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: true,
        arrows: true,
      }
    }
  ]
});

// Slick Slider for .collection__slider-2
$('.collection__slider-2').slick({
  slidesToShow: 12,
  slidesToScroll: 2,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 1500,
  speed: 1000,  // Adjust speed for smooth transition
  cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
  pauseOnHover: false,
arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        infinite: true,
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: false,
        arrows: true,
      }
    }
  ]
});



$(".custom_four_grid").click(function () {
  $(".custom_four_grid").addClass("custom_active"),
      $(".custom_three_grid").removeClass("custom_active"),
      $(".custom_list_grid").removeClass("custom_active"),
      $(".product-grid").removeClass("grid--3-col-desktop"),
      $(".product-grid").removeClass("custom-list-grid"),
      $(".product-grid").addClass("grid"),
      $(".product-grid").addClass("grid--2-col-tablet-down"),
      $(".product-grid").addClass("grid--4-col-desktop");
}),
$(".custom_list_grid").click(function () {
  $(".custom_list_grid").addClass("custom_active"),
      $(".custom_four_grid").removeClass("custom_active"),
      $(".custom_three_grid").removeClass("custom_active"),
      $(".product-grid").removeClass("grid"),
      $(".product-grid").removeClass("grid--2-col-tablet-down"),
      $(".product-grid").removeClass("grid--3-col-desktop"),
      $(".product-grid").removeClass("grid--4-col-desktop"),
      $(".product-grid").addClass("custom-list-grid");
});
// Product page tab section

class TabsManual {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab);
  }

  setSelectedTab(currentTab) {
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].classList.remove('is-hidden');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add('is-hidden');
      }
    }
  }

  moveFocusToTab(currentTab) {
    currentTab.focus();
  }

  moveFocusToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.moveFocusToTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index - 1]);
    }
  }

  moveFocusToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.moveFocusToTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.moveFocusToTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.moveFocusToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.moveFocusToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.moveFocusToTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.moveFocusToTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  // Since this example uses buttons for the tabs, the click onr also is activated
  // with the space and enter keys
  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

// Initialize tablist

window.addEventListener('load', function () {
  var tablists = document.querySelectorAll('[role=tablist].manual');
  for (var i = 0; i < tablists.length; i++) {
    new TabsManual(tablists[i]);
  }
});

// Mobile view only
  // Code to be executed when screen width is below 768px
  var accItem = document.getElementsByClassName('accordionItem');
  var accHD = document.getElementsByClassName('accordionItemHeading');

  for (var i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
  }

  function toggleItem() {
    var itemClass = this.parentNode.className;
    if (itemClass.indexOf('open') != -1) {
      this.parentNode.className = 'accordionItem close';
    } else {
      this.parentNode.className = 'accordionItem open';
    }
  }

  $(document).ready(function() {
      $('.custom_slider1').slick({
          dots: true,              
          arrows: false,
          infinite: true,        
          speed: 200,             
          slidesToShow: 1,        
          slidesToScroll: 1,      
          autoplay: true,         
          autoplaySpeed: 2000,     
          fade: true,              
          cssEase: 'linear',      
          responsive: [
              {
                  breakpoint: 768, 
                  settings: {
                      dots: true,    
                      arrows: false, 
                      fade: false,   
                  }
              },
              {
                  breakpoint: 480, 
                  settings: {
                      slidesToShow: 1, 
                      slidesToScroll: 1 
                  }
              }
          ]
      });
  });

document.addEventListener("DOMContentLoaded", function() {
    // Check if the element with the class exists on the page
    var noProductsTitle = document.querySelector("h2.title.title--primary");
    if (noProductsTitle && noProductsTitle.textContent.includes("No products found")) {
        // Update the text content
        noProductsTitle.textContent = "Summer’25 launching soon";
        // Add a custom class
        noProductsTitle.classList.add("not_found");
    }
});


document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".two-images-section");
  sections.forEach((section, index) => {
    const idNumber = 3 + index * 2; // 3, 5, 7, ...
    section.id = `section${idNumber}`;
  });
});